const ingredient = state => state.ingredient
const ingredients = state => state.ingredients

export default {
  ingredient,
  ingredients

}
